import { WidgetDefinition } from '../../models/WidgetDefinition';

export const QualityPercentageWidgetDefinition: WidgetDefinition = {
    baseType: 'qualityPercentage',
    group: 'Quality',
    highlights: ['Percentage of error'],
    icon: 'fa-dashboard',
    sortingOrder: 0,
    title: 'Quality percentage',
    type: 'qualityPercentage'
};